import { NavLink, Outlet, useNavigate } from "react-router-dom";
import { useState } from "react";
import { LayoutDashboard, FileText, Users, Settings, LogOut, KeyRound, ChevronDown, Tags, Wrench } from "lucide-react";
import { useAuth } from "../context/AuthContext";
import { BrandMark } from "./BrandMark";
import { ChangePasswordDialog } from "./ChangePasswordDialog";
import {
  DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuSeparator, DropdownMenuTrigger,
} from "./ui/dropdown-menu";

const links = [
  { to: "/", label: "Dashboard", icon: LayoutDashboard, end: true },
  { to: "/quotes", label: "Quotes", icon: FileText },
  { to: "/jobs", label: "Jobs", icon: Wrench },
  { to: "/customers", label: "Customers", icon: Users },
  { to: "/price-list", label: "Price List", icon: Tags },
];

export default function Layout() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [pwOpen, setPwOpen] = useState(false);
  const all = user?.role === "admin" ? [...links, { to: "/admin", label: "Admin", icon: Settings }] : links;

  return (
    <div className="min-h-screen bg-slate-50">
      <header className="sticky top-0 z-50 border-b-2 border-red-600 bg-zinc-950">
        <div className="mx-auto flex h-16 max-w-[1500px] items-center gap-3 px-3 sm:gap-8 sm:px-6">
          <NavLink to="/" data-testid="header-logo-link" className="shrink-0"><BrandMark dark testId="header-logo" /></NavLink>
          <nav className="flex min-w-0 flex-1 items-center gap-1 overflow-x-auto">
            {all.map(({ to, label, icon: Icon, end }) => (
              <NavLink key={to} to={to} end={end} data-testid={`nav-${label.toLowerCase()}`}
                className={({ isActive }) => `flex items-center gap-2 rounded-md px-3 py-2 text-sm font-medium transition-colors ${isActive ? "bg-red-600 text-white" : "text-zinc-300 hover:bg-zinc-800 hover:text-white"}`}>
                <Icon className="h-4 w-4" /><span className="hidden md:inline">{label}</span>
              </NavLink>
            ))}
          </nav>
          <div className="ml-auto shrink-0">
            <DropdownMenu>
              <DropdownMenuTrigger data-testid="user-menu-trigger" className="flex items-center gap-2 rounded-md px-3 py-2 text-sm text-zinc-200 hover:bg-zinc-800">
                <span className="grid h-7 w-7 place-items-center rounded-full bg-zinc-800 font-mono text-xs uppercase text-red-400">{user?.username?.[0]}</span>
                <span data-testid="current-username" className="hidden sm:inline">{user?.name || user?.username}</span>
                <ChevronDown className="h-4 w-4" />
              </DropdownMenuTrigger>
              <DropdownMenuContent align="end">
                <DropdownMenuItem data-testid="change-password-menu" onClick={() => setPwOpen(true)}><KeyRound className="mr-2 h-4 w-4" />Change password</DropdownMenuItem>
                <DropdownMenuSeparator />
                <DropdownMenuItem data-testid="logout-menu" onClick={() => { logout(); navigate("/login"); }}><LogOut className="mr-2 h-4 w-4" />Log out</DropdownMenuItem>
              </DropdownMenuContent>
            </DropdownMenu>
          </div>
        </div>
      </header>
      <main className="mx-auto max-w-[1500px] px-3 py-8 sm:px-6"><Outlet /></main>
      <ChangePasswordDialog open={pwOpen} onOpenChange={setPwOpen} />
    </div>
  );
}
